import messages from '../assets/i18n-data/messages'
import { createI18n } from 'vue-i18n'

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'ja',
  messages,
})

export default i18n
